import React, {useEffect, useState, useRef} from 'react'
import {withRouter} from 'react-router-dom'
import {Col, Row} from 'react-bootstrap'
import {Button, Form, Input, Select, DatePicker, Modal, notification, Spin, Alert, Empty} from "antd";
import UserInfo from "../auth/UserInfo";
import moment from "moment";
import HelperGeneral from "../../helpers/HelperGeneral";
import {trans} from "../../helpers/HelperGlobal";
import MaskedInput from "antd-mask-input";
import {setGlobalSpinner} from "../../services/redux/actions/GeneralAction";
import Api from "../../services/Api";
import Countdown, {zeroPad} from "react-countdown";
import {ExclamationCircleOutlined} from '@ant-design/icons';
import {FontAwesomeIcon} from "@fortawesome/react-fontawesome";
import {faPlus, faTrash} from "@fortawesome/free-solid-svg-icons";
import AddressModal from "./Consumer/basket/AddressModal";

const {confirm} = Modal;

const Profile = () => {
    const [modalOpen, setModalOpen] = useState(false);
    const [emailModalOpen, setEmailModalOpen] = useState(false);
    const [userOtpData, setUserOtpData] = useState({});
    const [step, setStep] = useState(1);
    const [addresses, setAddresses] = useState([]);
    const [addressShow, setAddressShow] = useState(false);
    const [addressItem, setAddressItem] = useState({});
    const [addressLoading, setAddressLoading] = useState(false);
    const [loading, setLoading] = useState(false);
    const [emailDate, setEmailDate] = useState(null);
    const [phoneDate, setPhoneDate] = useState(null);
    const [formData, setFormData] = useState([]);
    const [deleteAccountModalOpen, setDeleteAccountModalOpen] = useState(false);
    const [user, setUser] = useState(UserInfo.info());
    const inputRef = useRef(null);
    const [form] = Form.useForm();
    const [emailForm] = Form.useForm();

    useEffect(() => {
        getAddress();

        Api.getCustomer().then(r2 => {
            const {remember} = UserInfo.dataCheck();
            UserInfo.setUserInfo(r2?.data, remember);
            setUser(r2?.data);
        }).catch((e) => {
            HelperGeneral.alert(e);
        });

        if ((user?.user_roles_id === 4 || user?.user_roles_id === 6) && user?.company_id) {
            setLoading(true);
            Api.getCompany(user?.company_id).then(data => {
                form.setFieldsValue({
                    commercialName: data?.data?.name,
                    companyUuid: data?.data?.uuid
                })
                setLoading(false);
            }).catch((e) => {
                HelperGeneral.alert(e);
                setLoading(false);
            });
        }
    }, [])

    const onFinishOtp = (e) => {
        if (step === 1) {
            setLoading(true);
            const data = {
                type: 'gsm-change',
                telephone: e?.mobilePhone,
                send_type: 'sms',
            };
            Api.createContactOtp(data).then(r => {
                userOtpData.mobilePhone = e?.mobilePhone;
                setPhoneDate(Date.now() + (r?.data?.expired * 1000));
                setStep(2);
                setUserOtpData(userOtpData);
                setLoading(false);
            }).catch((e) => {
                setLoading(false);
                HelperGeneral.alert(e);
            })
        } else if (step === 2) {
            const data = {
                operation_type: 'gsm-change',
                telephone: userOtpData?.mobilePhone,
                code: e?.code,
                send_type: 'sms',
            };
            setLoading(true);
            Api.verifyOtp(data).then(r => {
                const innerData = {
                    telephone: userOtpData?.mobilePhone,
                    code: e?.code,
                    sms: r?.data
                };
                Api.userTelephoneUpdate(innerData).then(r => {
                    Api.getCustomer().then(r2 => {
                        const {remember} = UserInfo.dataCheck();
                        UserInfo.setUserInfo(r2?.data, remember);
                        setStep(1);
                        setUserOtpData({});
                        setModalOpen(false);
                        setPhoneDate(null)
                        form.setFieldsValue({
                            mobilePhone: r2?.data?.gsm,
                        });
                        setLoading(false);
                        HelperGeneral.alert("Telefon numaranız değiştirilmiştir.", "success");
                    }).catch((e) => {
                        setLoading(false);
                        HelperGeneral.alert(e);
                    });
                }).catch((e) => {
                    setLoading(false);
                    HelperGeneral.alert(e);
                })
            }).catch((e) => {
                setLoading(false);
                HelperGeneral.alert(e);
            })
        }
    }

    const onFinishEmailOtp = (e) => {
        const data = {
            operation_type: 'email-change',
            telephone: formData?.email,
            code: e?.code,
            send_type: 'email',
        };
        Api.verifyOtp(data).then(otpData => {
            setLoading(true);
            const innerData = {
                telephone: formData?.email,
                email: otpData?.data,
                code: e?.code,
            };

            Api.userEmailUpdate(innerData).then(r => {
                Api.getCustomer().then(r2 => {
                    const {remember} = UserInfo.dataCheck();
                    UserInfo.setUserInfo(r2?.data, remember);
                    form.setFieldsValue({
                        email: r2?.data?.email
                    })
                    emailForm.resetFields();
                    setEmailModalOpen(false);
                    setEmailDate(null)
                    setLoading(false);
                    notification['success']({
                        message: 'Başarılı!',
                        description: 'E-posta adresiniz güncellendi',
                    });
                }).catch((e) => {
                    setLoading(false);
                    HelperGeneral.alert(e);
                });
            }).catch((e) => {
                setLoading(false);
                HelperGeneral.alert(e);
            })
        }).catch((e) => {
            setLoading(false);
            HelperGeneral.alert(e);
        })
    }

    const onUpdatePress = (e) => {
        setFormData(e);
        if (e?.email === user?.email) {
            HelperGeneral.alert('E-posta adresi hesapta kayıtlı olan adres ile aynı. Güncellemek için lütfen farklı bir E-posta adresi giriniz.');
        } else {
            const formData = {
                telephone: e?.email,
                send_type: 'email',
                type: 'email-change',
            };
            setGlobalSpinner(true);
            Api.createContactOtp(formData).then(r => {
                setGlobalSpinner(false);
                setEmailDate(Date.now() + (r?.data?.expired * 1000));
                setEmailModalOpen(true);
            }).catch((e) => {
                setGlobalSpinner(false);
                HelperGeneral.alert(e);
            })
        }
    }

    const getAddress = () => {
        setAddressLoading(true);
        const user = UserInfo.info();
        Api.getAddressAll(user.id).then((e) => {
            setAddresses(e?.data);
            setAddressLoading(false);
        }).catch(e => {
            HelperGeneral.alert(e)
            setAddressLoading(false);
        })
    }

    const deleteAddress = (addressId) => {
        setTimeout(() => {
            Modal.confirm({
                type: 'warning',
                content: 'Adresinizi silmek istediğinize emin misiniz?',
                onOk() {
                    setGlobalSpinner(true);
                    Api.addressDelete(addressId).then(r => {
                        setGlobalSpinner(false);
                        getAddress();
                    }).catch((e) => {
                        setGlobalSpinner(false);
                        HelperGeneral.alert(e);
                    })
                },
                onCancel() {
                    Modal.destroyAll();
                },
            })
        }, 100)
    }

    const onAccountDeletionFinish = (e) => {
        Api.contactDelete(e.password).then(r => {
            UserInfo.logout2();
            window.location.href = '/login';
            notification['success']({
                message: 'Başarılı!',
                description: 'Hesap silme işlemi başarıyla gerçekleşti',
            });
        }).catch((e) => {
            HelperGeneral.alert(e);
        })
    }

    return (
        <div className={'box profile'}>
            {
                user?.user_roles_id !== 3 && (
                    <Alert
                        message={null}
                        description={"Bilgilerinizi güncellemek için lütfen yetkili ile iletişime geçiniz."}
                        type={"info"}
                        showIcon={true}
                        className={'mb-4'}
                    />
                )
            }
            <h2 className={'margin'}>Kişisel Bilgiler</h2>
            <Form
                form={form}
                layout={'vertical'}
                initialValues={{
                    ...user,
                    birthday: undefined,
                }}
                onFinish={(e) => {
                    return onUpdatePress(e)
                }}
            >
                <Row>
                    {
                        (user.user_roles_id === 4 || user.user_roles_id === 6) && (
                            <Col xs={12} md={6}>
                                <Spin spinning={loading} className={'w-100 h-100'}>
                                    <Form.Item
                                        label={'Eczane Ticari Ünvanı'}
                                        name={'commercialName'}
                                    >
                                        <Input disabled={true}/>
                                    </Form.Item>
                                </Spin>
                            </Col>
                        )
                    }
                    {
                        (user.user_roles_id === 4 || user.user_roles_id === 6) && (
                            <Col xs={12} md={6}>
                                <Spin spinning={loading} className={'w-100 h-100'}>
                                    <Form.Item
                                        label={'GLN Numarası'}
                                        name={'companyUuid'}
                                    >
                                        <Input disabled={true}/>
                                    </Form.Item>
                                </Spin>
                            </Col>
                        )
                    }
                    <Col xs={12} md={6}>
                        <Form.Item
                            label={'Ad'}
                            name={"first_name"}
                            rules={[{
                                required: false,
                            }]}
                        >
                            <Input disabled={true}/>
                        </Form.Item>
                    </Col>
                    <Col xs={12} md={6}>
                        <Form.Item
                            label={'Soyad'}
                            name={"last_name"}
                            rules={[{
                                required: false,
                            }]}
                        >
                            <Input disabled={true}/>
                        </Form.Item>
                    </Col>
                    <Col xs={12} md={6}>
                        <Form.Item
                            name={'gsm'}
                            label={"Cep Telefonu"}
                        >
                            <MaskedInput
                                mask={'(\\+90)111-111-11-11'}
                                disabled={true}
                                suffix={
                                    user?.user_roles_id === 3 && (
                                        <div
                                            className={"h-100 w-100 d-flex justify-content-center align-items-center"}
                                            onClick={() => {
                                                setModalOpen(true)
                                            }}
                                        >
                                            Değiştir
                                        </div>
                                    )
                                }
                            />
                        </Form.Item>
                    </Col>
                    <Col xs={12} md={6}>
                        <Form.Item
                            label={'E-posta Adresi'}
                            className={"pb-0 mb-0"}
                            name={'email'}
                            rules={[{
                                required: user?.user_roles_id === 3,
                                type: "email"
                            }]}
                        >
                            <Input
                                ref={inputRef}
                                disabled={user?.user_roles_id !== 3}
                                suffix={
                                    user?.user_roles_id === 3 && (
                                        <Form.Item className={'m-0'}>
                                            <Button className={'suffix-btn'} htmlType={'submit'}>Güncelle</Button>
                                        </Form.Item>
                                    )
                                }
                            />
                        </Form.Item>
                    </Col>
                    <Col xs={12} className={'address-profile-col'}>
                        <Spin spinning={addressLoading}>
                            <Form.Item
                                label={'Adresler'}
                                name={null}
                            >
                                <Row>
                                    {
                                        addresses?.length > 0 ? (
                                            addresses?.map((v, i) => (
                                                <Col xs={12} md={4} className={'d-flex mb-3 mb-sm-0'} key={i}>
                                                    <div className={user?.user_roles_id !== 3 ? 'address-box disabled' : 'address-box'}>
                                                        <Row className={'d-flex'}>
                                                            <Col xs={12} className={'mb-2'}>
                                                                {v?.name + ' ' + v?.last_name}
                                                            </Col>
                                                            <Col xs={12} className={'mb-2'}><b>{v?.title}</b></Col>
                                                            <Col xs={12} className={'mb-2'}>{v?.address}</Col>
                                                            <Col xs={12}>{v?.telephone}</Col>
                                                            {
                                                                user?.user_roles_id === 3 && (
                                                                    <>
                                                                        <Col xs={6} className={'mt-4 d-flex justify-content-start align-items-center'}>
                                                                            <a
                                                                                onClick={() => {
                                                                                    setAddressItem(v)
                                                                                    setAddressShow(true)
                                                                                }}
                                                                            >
                                                                                Düzenle
                                                                            </a>
                                                                        </Col>
                                                                        <Col xs={6} className={'mt-4 d-flex justify-content-end align-items-center'}>
                                                                            <a
                                                                                onClick={() => {
                                                                                    deleteAddress(v?.id)
                                                                                }}
                                                                            >
                                                                                <FontAwesomeIcon icon={faTrash}/>
                                                                            </a>
                                                                        </Col>
                                                                    </>
                                                                )
                                                            }
                                                        </Row>
                                                    </div>
                                                </Col>
                                            ))
                                        ) : (
                                            (user?.user_roles_id === 4 || user?.user_roles_id === 6) && (
                                                <Col xs={12} className={'d-flex justify-content-center align-items-center mb-3 mb-sm-0'}>
                                                    <Empty description={'Kayıtlı adres bulunamadı.'}/>
                                                </Col>
                                            )
                                        )
                                    }
                                    {
                                        addresses?.length < 3 && user?.user_roles_id === 3 && (
                                            <Col xs={12} md={4} className={'d-flex mb-2 mb-sm-0'}>
                                                <div
                                                    className={'address-box add'}
                                                    onClick={() => {
                                                        setAddressItem({})
                                                        setAddressShow(true)
                                                    }}
                                                >
                                                    <Row className={'h-100'}>
                                                        <Col xs={12} className={'d-flex align-items-end justify-content-center mb-2'}>
                                                            <FontAwesomeIcon icon={faPlus}/>
                                                        </Col>
                                                        <Col xs={12} className={'d-flex align-items-start justify-content-center'}>
                                                            Teslimat Adresi Ekle
                                                        </Col>
                                                    </Row>
                                                </div>
                                            </Col>
                                        )
                                    }
                                </Row>
                            </Form.Item>
                        </Spin>
                    </Col>
                </Row>
            </Form>
            <Row>
                <Col xs={12} className={'d-flex align-items-center mb-0 justify-content-center text-center'}>
                    <a onClick={() => setDeleteAccountModalOpen(true)} className={'continue-shop-text text-danger'}>
                        Hesabı Sil
                    </a>
                </Col>
            </Row>
            {
                modalOpen && (
                    <Modal
                        title={"Cep telefonunu doğrula"}
                        onCancel={() => {
                            setModalOpen(false);
                            setPhoneDate(null)
                            setStep(1);
                        }}
                        visible={modalOpen}
                        footer={false}
                        className={"basket"}
                    >
                        <Form
                            layout={'vertical'}
                            onFinish={(e) => {
                                return onFinishOtp(e)
                            }}
                        >
                            {
                                step === 1 && (
                                    <Form.Item
                                        name={'mobilePhone'}
                                        label="Yeni Cep Telefonu"
                                        rules={[
                                            {
                                                validator: (_, value) => {
                                                    const digits = String(value || "").replace(/\D/g, "");

                                                    if (digits.length === 0) {
                                                        return Promise.reject(
                                                            new Error("Telefon numarası zorunludur")
                                                        );
                                                    }

                                                    if (digits.length !== 12) {
                                                        return Promise.reject(
                                                            new Error("Telefon numarasını eksiksiz giriniz")
                                                        );
                                                    }

                                                    return Promise.resolve();
                                                },
                                            },
                                        ]}
                                    >
                                        <MaskedInput mask={'(\\+90)111-111-11-11'}/>
                                    </Form.Item>
                                )
                            }
                            {
                                step === 2 && (
                                    <>
                                        <div className={'password-reset'}>
                                            {trans('t3')}
                                            <span className={'time'}>
                                                <Countdown
                                                    precision={0}
                                                    renderer={({minutes, seconds,}) => (
                                                        <span>
                                                            {trans('t2', {minutes: zeroPad(minutes), seconds: zeroPad(seconds)})}
                                                        </span>
                                                    )}
                                                    onComplete={() => {
                                                        setStep(step - 1);
                                                        setPhoneDate(null)
                                                        if (step === 3) {
                                                            HelperGeneral.alert('Doğrulama süresi sona erdi.');
                                                        }
                                                    }}
                                                    date={phoneDate}
                                                />
                                            </span>
                                        </div>
                                        <Form.Item
                                            name={'code'}
                                            rules={[() => ({
                                                validator(_, value) {
                                                    const v = HelperGeneral.telephoneClear(value);
                                                    if (v.length === 5) {
                                                        return Promise.resolve()
                                                    }
                                                    return Promise.reject(new Error(trans('login.t22')))
                                                },
                                            })]}
                                            help={'Telefonunuza gönderilen 5 haneli onay kodunu giriniz.'}
                                        >
                                            <MaskedInput
                                                mask={'11111'}
                                                autoComplete={'new-password'}
                                                size={5}
                                            />
                                        </Form.Item>
                                    </>
                                )}
                            <hr/>
                            <Form.Item className={"d-flex justify-content-center text-center mb-0"}>
                                <Button type={"primary"} htmlType={'submit'} loading={loading}>{step === 1 ? 'SMS Gönder' : 'Doğrula'}</Button>
                            </Form.Item>
                        </Form>
                    </Modal>
                )
            }
            {
                emailModalOpen && (
                    <Modal
                        title={"E-posta adresini doğrula"}
                        onCancel={() => {
                            form.setFieldsValue({
                                email: user?.email
                            })
                            emailForm.resetFields();
                            setEmailModalOpen(false);
                            setEmailDate(null)
                        }}
                        visible={emailModalOpen}
                        footer={false}
                        className={"basket"}
                    >
                        <Form
                            form={emailForm}
                            layout={'vertical'}
                            initialValues={""}
                            onFinish={(e) => {
                                return onFinishEmailOtp(e)
                            }}
                        >
                            <div className={'password-reset'}>
                                {trans('t3')}
                                <span className={'time'}>
                                    <Countdown
                                        precision={0}
                                        renderer={({minutes, seconds}) => (
                                            <span>
                                                {trans('t2', {minutes: zeroPad(minutes), seconds: zeroPad(seconds)})}
                                            </span>
                                        )}
                                        onComplete={() => {
                                            form.setFieldsValue({
                                                email: user?.email
                                            })
                                            emailForm.resetFields();
                                            setEmailModalOpen(false);
                                            setEmailDate(null)
                                            HelperGeneral.alert('Doğrulama süresi sona erdi.');
                                        }}
                                        date={emailDate}
                                    />
                                </span>
                            </div>
                            <Form.Item
                                name={'code'}
                                rules={[() => ({
                                    validator(_, value) {
                                        const v = HelperGeneral.telephoneClear(value);
                                        if (v.length === 5) {
                                            return Promise.resolve()
                                        }
                                        return Promise.reject(new Error(trans('login.t22')))
                                    },
                                })]}
                                help={'Yeni E-posta adresinize gönderilen 5 haneli onay kodunu giriniz.'}
                            >
                                <MaskedInput
                                    mask={'11111'}
                                    autoComplete={'new-password'}
                                    size={5}
                                />
                            </Form.Item>
                            <Form.Item className={"d-flex justify-content-center text-center mb-0 mt-3"}>
                                <Button type="primary" htmlType={'submit'} loading={loading}>Doğrula</Button>
                            </Form.Item>
                        </Form>
                    </Modal>
                )
            }
            {
                deleteAccountModalOpen && (
                    <Modal
                        title={"Hesabının silinmesini doğrula"}
                        onCancel={() => {
                            setDeleteAccountModalOpen(false);
                        }}
                        visible={deleteAccountModalOpen}
                        footer={false}
                    >
                        <Form onFinish={(e) => onAccountDeletionFinish(e)}>
                            <div className={'d-flex flex-column justify-content-center align-items-center text-center'}>
                                <span className={'desc mb-4'}>
                                    Hesabınızı silmeniz durumunda sistemimizde kayıtlı olan kullanıcı bilgileriniz, mevcut tüm satın alma kayıtlarınız ve ayarlarınız silinir.
                                    Bu işlemlerin geri alınması imkansızdır.
                                </span>
                                <Form.Item
                                    className={"pb-0 mb-0 w-100"}
                                    name={'password'}
                                    rules={[{
                                        required: true,
                                        message: 'Şifre gerekli bir alan'
                                    }]}
                                >
                                    <Input.Password placeholder={'*************'} className={'w-100'}/>
                                </Form.Item>
                                <span className={'desc mt-1'}>
                                    Hesabınızın silinmesini doğrulamak için lütfen mevcut şifrenizi giriniz.
                                </span>
                                <Button htmlType={"submit"} className={'red-warning-btn mt-4'}>
                                    <span>Hesabı Sil</span>
                                </Button>
                            </div>
                        </Form>
                    </Modal>
                )
            }
            {
                addressShow && (
                    <AddressModal
                        show={addressShow}
                        showSend={(show) => {
                            setAddressShow(show)
                        }}
                        getAddress={getAddress}
                        item={addressItem}
                    />
                )
            }
        </div>
    )
}

export default withRouter(Profile);
